import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    // Get all checked DSPs
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]')
    const selectedDsps = Array.from(checkboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.dataset.dsp)

    // If no DSPs selected, prevent unchecking the last one
    if (selectedDsps.length === 0) {
      event.target.checked = true
      return
    }

    // Reload page with selected DSPs
    const url = new URL(window.location.href)
    url.searchParams.delete('dsps[]')
    selectedDsps.forEach(dsp => url.searchParams.append('dsps[]', dsp))

    window.location.href = url.toString()
  }
}
